import React from 'react';
import PropTypes from 'prop-types';
import TreeRow from './TreeRow';
import IconOrganization from 'svgIcons/MotionPortalIcons/IconOrganization';
import { map } from 'lodash';
import SiteNode from './SiteNode';
import { useNodeExpansion } from './HierarchyExpansionContext';

const SubOrganizationNode = ({
    organization,
    depth,
    selectedAsset,
    onSelectAsset,
    leftPanelSize,
    allAssets,
    conditionIndicesView,
    selectionNodeIds,
    selectedAssetSignalCounts
}) => {
    const { expanded, toggle } = useNodeExpansion(`subOrg-${organization?.organizationId}`);
    const hasSelectionDot = !!selectionNodeIds?.has(`subOrg-${organization?.organizationId}`);

    return (
        <>
            <TreeRow
                depth={depth}
                icon={<IconOrganization />}
                label={organization.name}
                hasChildren={(organization?.sites?.length || 0) > 0}
                isExpanded={expanded}
                condition={organization?.condition}
                onToggle={toggle}
                hasSelectionDot={hasSelectionDot}
            />
            {expanded && map(organization?.sites, site =>
                <SiteNode
                    key={site?.siteId}
                    site={site}
                    depth={depth + 1}
                    selectedAsset={selectedAsset}
                    onSelectAsset={onSelectAsset}
                    leftPanelSize={leftPanelSize}
                    allAssets={allAssets}
                    conditionIndicesView={conditionIndicesView}
                    selectionNodeIds={selectionNodeIds}
                    selectedAssetSignalCounts={selectedAssetSignalCounts}
                />
            )}
        </>
    );
};

SubOrganizationNode.propTypes = {
    organization: PropTypes.object.isRequired,
    depth: PropTypes.number.isRequired,
    selectedAsset: PropTypes.object,
    onSelectAsset: PropTypes.func,
    leftPanelSize: PropTypes.number,
    showThreshold: PropTypes.bool,
    showTrend: PropTypes.bool,
    allAssets: PropTypes.array,
    conditionIndicesView: PropTypes.string,
    selectionNodeIds: PropTypes.instanceOf(Set),
    selectedAssetSignalCounts: PropTypes.object
};

export default SubOrganizationNode;
